const initialState = {
  loading: false,
  vehicles: [],
  spots: [],
  carInfo: [],
};

const PARKING_REDUCER = (state = initialState, { type, payload }) => {
  switch (type) {
    case "PARKING_LOADING":
      return { ...state, loading: true };
    case "PARKING_COMPLETE":
      return { ...state, loading: false };
    case "SET_VEHICLES":
      return { ...state, vehicles: payload };
    case "SET_PARKING_SPOTS":
      return { ...state, spots: payload };
    case "SET_CAR_INFO":
      return { ...state, carInfo: payload };
    case "LOGOUT":
      return { ...initialState };
    default:
      return state;
  }
};

export default PARKING_REDUCER;
